import { cn } from 'noddi-ui-common';
import { NoddiBasicCard } from 'noddi-ui-web';
import { type ReactNode } from 'react';

type MapLegendProps = {
  children: ReactNode;
  className?: string;
};

export const MapLegend = ({ children, className }: MapLegendProps) => (
  <NoddiBasicCard
    size='small'
    className={cn('absolute bottom-4 left-4 z-20 flex flex-col gap-2 p-3 text-xs', className)}
  >
    {children}
  </NoddiBasicCard>
);

type MapLegendItemProps = {
  icon: ReactNode;
  children: ReactNode;
  onClick?: () => void;
  title?: string;
};

export const MapLegendItem = ({ icon, children, onClick, title }: MapLegendItemProps) => {
  const className = cn(
    'flex items-center gap-1.5',
    onClick && 'rounded-md px-1 py-0.5 text-left transition-colors hover:bg-accent'
  );

  if (onClick) {
    return (
      <button type='button' onClick={onClick} title={title} className={className}>
        <span className='flex w-4 items-center justify-center'>{icon}</span>
        <span>{children}</span>
      </button>
    );
  }

  return (
    <div className={className} title={title}>
      <span className='flex w-4 items-center justify-center'>{icon}</span>
      <span>{children}</span>
    </div>
  );
};
